import { render, staticRenderFns } from "./ReceiptIssueRecord.vue?vue&type=template&id=2a7ad21a&scoped=true&"
import script from "./ReceiptIssueRecord.vue?vue&type=script&lang=js&"
export * from "./ReceiptIssueRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptIssueRecord.vue?vue&type=style&index=0&id=2a7ad21a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ad21a",
  null
  
)

export default component.exports